import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Lesson from 'pages/Lesson';
import Roadmap from 'pages/Roadmap';
import NotFound from 'pages/NotFound';
import Landing from 'pages/Landing';
import Summary from 'pages/Summary';
import Settings from 'pages/Settings';
import Signup from 'pages/Signup';
import Login from 'pages/Login';
import ForgotPass from 'pages/ForgotPass';
import UpdatePass from 'pages/UpdatePass';
import Subscription from 'pages/Subscription';
import SubscriptionSuccess from 'pages/SubscriptionSuccess';
import Terms from 'pages/Terms';
import Privacy from 'pages/Privacy';
import Admin from 'pages/Admin';
import AdminUnits from 'pages/AdminUnits';
import AdminStats from 'pages/AdminStats';
import AdminCreator from 'pages/AdminCreator';
import AdminCharityCodes from 'pages/AdminCharityCodes';

import AuthStart from 'pages/AuthStart';
import AuthCallback from 'pages/AuthCallback';
import AuthRedirect from 'pages/AuthRedirect';

import { UserProvider } from 'utils/userContext';
import { AudioProvider } from 'utils/audioContext';
import ErrorBoundary from 'components/ErrorBoundary';
import ROUTES from 'utils/routes.js';

import './App.css';



function App() {
  const [forceLightMode, setForceLightMode] = React.useState(false);

  React.useEffect(() => {
    const stored = localStorage.getItem("kodeo.forceLightMode");
    setForceLightMode(stored === "true");
  }, []);

  return (
    <div className={`App h-full ${forceLightMode ? "kodeo_light" : ""}`}>
      <AudioProvider>
        <UserProvider>
          <Routes>
            <Route path={ROUTES.ADMIN} title="Admin | Kodeo" element={<AuthRedirect><Admin /></AuthRedirect>} />
            <Route path={ROUTES.ADMIN_UNITS} title="Admin Units | Kodeo" element={<AuthRedirect><AdminUnits /></AuthRedirect>} />
            <Route path={ROUTES.ADMIN_STATS} title="Admin Stats | Kodeo" element={<AuthRedirect><AdminStats /></AuthRedirect>} />
            <Route path={ROUTES.ADMIN_CREATOR} title="Admin Creator | Kodeo" element={<AuthRedirect><AdminCreator /></AuthRedirect>} />
            <Route path={ROUTES.ADMIN_CHARITY_CODES} title="Admin Charity Codes | Kodeo" element={<AuthRedirect><AdminCharityCodes /></AuthRedirect>} />

            <Route path={ROUTES.LESSON} title="Lesson | Kodeo" element={<AuthRedirect requirePaidAccess={true}><ErrorBoundary><Lesson /></ErrorBoundary></AuthRedirect>} />
            <Route path={ROUTES.LESSONS} title="Lessons | Kodeo" element={<AuthRedirect requirePaidAccess={true}><ErrorBoundary><Roadmap /></ErrorBoundary></AuthRedirect>} />
            <Route path={ROUTES.SUMMARY} title="Summary | Kodeo" element={<AuthRedirect requirePaidAccess={true}><Summary /></AuthRedirect>} />
            <Route path={ROUTES.SETTINGS} title="Settings | Kodeo" element={<AuthRedirect><Settings /></AuthRedirect>} />
            <Route path={ROUTES.SETTINGS + "/:tab"} title="Settings | Kodeo" element={<AuthRedirect><Settings /></AuthRedirect>} />
            <Route path={ROUTES.SUBSCRIPTION} title="Subscription | Kodeo" element={<AuthRedirect><Subscription /></AuthRedirect>} />
            <Route path={ROUTES.SUBSCRIPTION_SUCCESS} title="Payment Successful | Kodeo" element={<AuthRedirect><SubscriptionSuccess /></AuthRedirect>} />
            <Route path={ROUTES.LOGIN} title="Login | Kodeo" element={<Login />} />
            <Route path={ROUTES.SIGNUP} title="Sign Up | Kodeo" element={<Signup />} />
            <Route path={ROUTES.TERMS} title="Terms of Service | Kodeo" element={<Terms />} />
            <Route path={ROUTES.PRIVACY} title="Privacy Policy | Kodeo" element={<Privacy />} />
            <Route path={ROUTES.FORGOT_PASSWORD} title="Forgot Password | Kodeo" element={<ForgotPass />} />
            <Route path={ROUTES.UPDATE_PASSWORD} title="Update Password | Kodeo" element={<UpdatePass />} />
            <Route path={ROUTES.AUTH_START} title="Google Auth | Kodeo" element={<AuthStart />} />
            <Route path={ROUTES.AUTH_CALLBACK} title="Google Auth | Kodeo" element={<AuthCallback />} />
            <Route path={ROUTES.LANDING} title="Landing | Kodeo" element={<Landing />} />
            <Route path={ROUTES.NOT_FOUND} element={<NotFound />} />
          </Routes>
        </UserProvider>
      </AudioProvider>
    </div>
  );
}

export default App;
